export default "__VITE_ASSET__e0719455__"